<template>
  <VueTypeaheadBootstrap
    v-model="search"
    :data="municipios"
    :serializer="(item) => item.estado_sigla + ' / ' + item.nome"
    :placeholder="placeholder"
    @input="findMunicipio"
    @hit="municipio = $event"
    class="form-control form-control-custom"
    :class="[stateClass, sizeClass]"
    :size="size"
  />
</template>

<script>
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";
import { mapActions } from "vuex";
import { debounce } from "lodash";

import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";

const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: {},
    placeholder: {
      type: String,
      default: "Buscar  ...",
    },
    uf: {
      type: String,
      default: null,
    },
    return_object: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
    },
  })
);

export default {
  components: { VueTypeaheadBootstrap },
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    municipio: null,
    search: "",
    municipios: [],
  }),
  computed: {
    sizeClass() {
      return "form-control-" + this.size;
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionFind", "ActionFindById"]),
    findMunicipio: debounce(async function () {
      let payload = { q: this.search };
      if (this.uf) {
        payload.estado_sigla = this.uf;
      }
      var municipios = await this.ActionFind(payload);
      this.municipios = municipios.data;
    }, 500),

    async setMunicipioByIbge(ibge) {
      if (ibge) {
        let municipio = await this.ActionFindById(ibge);
        if (municipio.id) {
          this.municipio = municipio;
        }
      }
    },
  },
  watch: {
    search: function (value) {
      if (value === "") {
        this.municipio = null;
      }
    },
    municipio: function () {
      if (this.municipio) {
        this.search = this.municipio.nome;
        this.municipios = [this.municipio];
        this.$emit("input", this.municipio.id);
      } else {
        this.$emit("input", null);
      }
    },
    value: function (value) {
      let ibge = this.return_object ? value.id : value;
      this.setMunicipioByIbge(value);
    },
  },
  async created() {
    if (this.value) {
      this.setMunicipioByIbge(this.value);
    }
  },
};
</script>

<style lang="scss">
.form-control-custom {
  margin-left: 0 !important;
  padding-left: 0 !important;
  padding-top: 0 !important;

  .form-control {
    border: none !important;
    background: transparent !important;
  }
}
</style>
